document.addEventListener("DOMContentLoaded", function(event) {
  let quantityButtons = document.querySelectorAll(".quantity__button");
  let removeButtons = document.querySelectorAll(".cart-remove-button");
  let addonButton = document.querySelectorAll(".addon_button");
  if(quantityButtons != null) {
    // quantityButtons.forEach(button => {
    //   button.addEventListener("click", giftWrapUpdate);
    // });
  }

  if(removeButtons != null) {
    // removeButtons.forEach(button => {
    //   button.addEventListener("click", giftWrapUpdate);
    // });
  }

  if(addonButton != null) {
    // addonButton.forEach(button => {
    //   button.addEventListener("click", giftWrapUpdate);
    // });
  }
  let inEligibleText = document.querySelector('#gift-wrap-not-eligible');
  //let eligibleText = document.querySelector('#gift-wrap-eligible');
  let defaultText = document.querySelector('#gift-wrap-default');

  window.giftWrapUpdate = function() {
    console.log('giftwrapupdate')
    //For opacity animation
    inEligibleText.classList.add("opacity-transition");
    //eligibleText.classList.add("opacity-transition");

    // setTimeout(function() {
      console.log('checking gift wrap eligibility');
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          let noWrapin = false;
          let items = cart.items;

          items.forEach(element => {
            if (element.properties._noWrapin == 'true') {
              noWrapin = true;
            }
          });
          if (noWrapin) {
            console.log('hide gift wrap')
            defaultText.classList.add("hidden");
            //eligibleText.classList.add("hidden");
            inEligibleText.classList.remove("hidden");
            inEligibleText.classList.remove("opacity-transition");
          } else {
            console.log('show gift wrap')
            //defaultText.classList.add("hidden");
            //eligibleText.classList.remove("hidden");
            inEligibleText.classList.add("hidden");
            //eligibleText.classList.remove("opacity-transition");
            let ptwMount = document.querySelector('.wrapin-app #ptw-wrapin');
            if (!ptwMount || typeof ptwLoadGiftWrap !== 'function') return;
            ptwMount.innerHTML = ptwLoadGiftWrap();
            var theDiv = document.getElementsByClassName("ptw-message-note")[0];
            var text = document.createElement("p");
            text.className = 'giftwrap_subtext'
            text.innerHTML = '*All products within your order will be wrapped together';
            theDiv?.appendChild(text);
            document.getElementById("ptw-gift-needed")?.labels[0].append('*')
          }
        }
      });

      //Loop through and re-apply event listener(s) every time
      //You MUST do this because the whole HTML refreshes on change() and you lose the original event listener(s)
      let quantityButtons = document.querySelectorAll(".quantity__button");
      let removeButtons = document.querySelectorAll(".cart-remove-button");

      if(quantityButtons != null) {
        quantityButtons.forEach(button => {
          button.addEventListener("click", giftWrapUpdate);

          //if gift does not have FREE GIFT in the title and the liquid doesn't catch it, this will
          if(button.style.pointerEvents) {
            let quantityHide = button.parentNode.parentNode.parentNode;
            quantityHide.style.visibility = "hidden";
          }
        });
      }

      if(removeButtons != null) {
        removeButtons.forEach(button => {
          button.addEventListener("click", giftWrapUpdate);
        });
      }
    // }, 500);
  }

  // Watch for mutations, from Free Gift addition
  let target = document.querySelector('.content-for-layout');
  let observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      let quantityButtons = document.querySelectorAll(".quantity__button");
      let removeButtons = document.querySelectorAll(".cart-remove-button");
      let addonButton = document.querySelectorAll(".addon_button");

      if(quantityButtons != null) {
        quantityButtons.forEach(button => {
          button.addEventListener("click", giftWrapUpdate);
        });
      }

      if(removeButtons != null) {
        removeButtons.forEach(button => {
          button.addEventListener("click", giftWrapUpdate);
        });
      }

      if(addonButton != null) {
        addonButton.forEach(button => {
          button.addEventListener("click", giftWrapUpdate);
        });
      }
    });
  });

  let config = {
    attributes: true,
    childList: true,
    characterData: true
  };

  observer.observe(target, config);
  //end mutation observe
});